import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class DriverHaltEntity {
  id?: string
  driverId?: number
  driver?: DriverEntity
  startedAt?: string
  endedAt?: string | null
  reason?: string | null
  createdAt?: string
}
